module.exports = "<div class=\"user-feedback animated shake layout-column layout-align-start-center h-100 {{type}}\"><div class=\"flex-nogrow message text-center\"><div class=\"icon\"><i class=\"zmdi zmdi-{{icon}}\"></i></div><div class=\"message\">{{message}}</div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/user-feedback/user-feedback.component.pug
// module id = 621
// module chunks = 0